import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ProcessSection } from '../components/ProcessSection';
import { HowItWorks } from '../components/HowItWorks';
import { CalculatorSection } from '../components/CalculatorSection';
import { ComparisonTable } from '../components/ComparisonTable';
import { EcosystemVision } from '../components/EcosystemVision';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-100 selection:text-brand-900" data-id="element-521">
      <Navbar data-id="element-522" />
      <main data-id="element-523">
        <Hero data-id="element-524" />
        <ProcessSection data-id="element-525" />
        <HowItWorks data-id="element-526" />
        <CalculatorSection data-id="element-527" />
        <ComparisonTable data-id="element-528" />
        <EcosystemVision data-id="element-529" />
        <FinalCTA data-id="element-530" />
      </main>
      <Footer data-id="element-531" />
    </div>;
}